import React from "react";
import { motion } from "framer-motion";
import { STATS } from "../../data/staticData";

export default function StatsBar() {
  return (
    <section className="py-20" data-testid="stats-bar">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.05, duration: 0.5, ease: [0.25, 1, 0.5, 1] }}
            className="border-l-2 border-terra pl-5"
          >
            <div className="font-mono text-4xl sm:text-5xl font-semibold tracking-tighter">{s.value}</div>
            <div className="text-xs uppercase tracking-[0.18em] text-inkSoft mt-2">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
